<div class="container">
    <!-- Auto-refresh indicator -->
    <div class="auto-refresh-indicator" *ngIf="refreshing && !loading">
        <div class="refresh-bar"></div>
        <small class="refresh-message">
            <i class="fa fa-sync-alt spinning"></i>
            Auto-refreshing data...
        </small>
    </div>

    <div class="mt-5">
        <div class="page-header">
            <div class="header-top">
                <h3 class="balance-amount">Transaction History</h3>

                <!-- Refresh Button -->
                <button class="refresh-btn"
                        (click)="refreshTransactions()"
                        [disabled]="refreshing"
                        [class.refreshing]="refreshing">
                    <i class="fa fa-sync-alt" [class.spinning]="refreshing"></i>
                    <span class="refresh-text">{{ refreshing ? 'Refreshing...' : 'Refresh' }}</span>
                </button>
            </div>

            <!-- Date Filters -->
            <div class="filter-section mt-3">
                <div class="filter-buttons d-flex flex-wrap gap-2 mb-3">
                    <button class="btn filter-btn"
                            [class.active]="filterType === ''"
                            (click)="setDateFilter('')">
                        <i class="fa fa-list"></i> All
                    </button>
                    <button class="btn filter-btn"
                            [class.active]="filterType === 'today'"
                            (click)="setDateFilter('today')">
                        <i class="fa fa-calendar-day"></i> Today
                    </button>
                    <button class="btn filter-btn"
                            [class.active]="filterType === 'yesterday'"
                            (click)="setDateFilter('yesterday')">
                        <i class="fa fa-calendar-minus"></i> Yesterday
                    </button>
                    <button class="btn filter-btn"
                            [class.active]="filterType === 'weekly'"
                            (click)="setDateFilter('weekly')">
                        <i class="fa fa-calendar-week"></i> This Week
                    </button>
                    <button class="btn filter-btn"
                            [class.active]="filterType === 'custom'"
                            (click)="setDateFilter('custom')">
                        <i class="fa fa-calendar-alt"></i> Custom Range
                    </button>
                </div>

                <!-- Custom Date Range Picker -->
                <div class="custom-date-range" *ngIf="showDatePicker">
                    <div class="date-inputs">
                        <div class="form-group">
                            <label for="startDate">From Date:</label>
                            <input type="date"
                                   id="startDate"
                                   class="form-control"
                                   [(ngModel)]="startDate"
                                   [max]="today">
                        </div>
                        <div class="form-group">
                            <label for="endDate">To Date:</label>
                            <input type="date"
                                   id="endDate"
                                   class="form-control"
                                   [(ngModel)]="endDate"
                                   [max]="today"
                                   [min]="startDate">
                        </div>
                        <div class="form-group">
                            <button class="btn btn-primary apply-btn"
                                    (click)="applyCustomDateFilter(startDate, endDate)"
                                    [disabled]="!startDate || !endDate">
                                <i class="fa fa-check"></i> Apply Filter
                            </button>
                        </div>
                    </div>
                </div>

                <!-- Filter Summary -->
                <div class="filter-summary" *ngIf="filterType">
                    <small class="text-muted">
                        <i class="fa fa-info-circle"></i>
                        Showing {{ capitalizeFirstLetter(filterType) }} transactions
                        <span *ngIf="startDate && endDate && filterType === 'custom'">
                            from {{ startDate | date:'mediumDate' }} to {{ endDate | date:'mediumDate' }}
                        </span>
                    </small>
                </div>
            </div>
        </div>

        <!-- Loading State -->
        <div class="loading-container" *ngIf="loading">
            <div class="loader-wrapper">
                <div class="main-loader">
                    <div class="loader-bar"></div>
                    <div class="loader-bar"></div>
                    <div class="loader-bar"></div>
                    <div class="loader-bar"></div>
                </div>
                <p class="loading-text">Loading transactions...</p>
            </div>
        </div>

        <!-- Content Area -->
        <div class="content-area" [class.loading]="loading">

        <!-- Content Area -->
        <div class="content-area" [class.loading]="loading">
            <!-- Empty State -->
            <div class="empty-state" *ngIf="!loading && (!filteredTransactions || filteredTransactions.length === 0)">
                <div class="empty-content">
                    <i class="fa fa-receipt empty-icon"></i>
                    <h4>No Transactions Found</h4>
                    <p class="text-muted">
                        <span *ngIf="filterType">No transactions found for the selected date range.</span>
                        <span *ngIf="!filterType">You haven't made any transactions yet.</span>
                    </p>
                    <button class="btn btn-outline-primary"
                            *ngIf="filterType"
                            (click)="setDateFilter('')">
                        <i class="fa fa-refresh"></i> Show All Transactions
                    </button>
                </div>
            </div>

            <!-- Table for Large Screens -->
            <div class="table-responsive mt-4 d-none d-md-block" *ngIf="!loading && filteredTransactions && filteredTransactions.length > 0">
                <table class="table table-bordered table-striped align-middle table-modern">
                    <thead>
                        <tr>
                            <th>S/N</th>
                            <th>Amount (₦)</th>
                            <th>Source Account</th>
                            <th>Destination Account</th>
                            <th>Reference</th>
                            <th>Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of filteredTransactions | paginate: { itemsPerPage: itemsPerPage, currentPage: page, totalItems: total }; let i = index">
                            <td>{{ ((page || 1) - 1) * (itemsPerPage || 10) + i + 1 }}</td>
                            <td class="amount-cell">
                                <span class="amount">{{ item.amount_paid | currency: '₦' }}</span>
                            </td>
                            <td>{{ item.source_account_name }}</td>
                            <td>{{ item.destination_account_number }}</td>
                            <td class="reference-cell">
                                <span class="reference">{{ item.reference }}</span>
                            </td>
                            <td>{{ item.created_at | date:'medium' }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- Card View for Mobile -->
            <div class="d-md-none" *ngIf="!loading && filteredTransactions && filteredTransactions.length > 0">
                <div class="transaction-card" *ngFor="let item of filteredTransactions | paginate: { itemsPerPage: itemsPerPage, currentPage: page, totalItems: total }">
                    <div class="transaction-header">
                        <span class="amount-badge">{{ item.amount_paid | currency: '₦' }}</span>
                        <span class="date-badge">
                          <span class="date-primary">{{item.created_at | date:'MMM dd, yyyy'}} </span>
                          <small class="date-time">{{item.created_at | date:'HH:mm'}}</small>
                        </span>
                    </div>
                    <div class="transaction-info">
                        <div class="info-row">
                            <i class="fa fa-building"></i>
                            <strong>Source:</strong> {{ item.source_account_name }}
                        </div>
                        <div class="info-row">
                            <i class="fa fa-credit-card"></i>
                            <strong>Destination:</strong> {{ item.destination_account_number }}
                        </div>
                        <!-- <div class="info-row">
                            <i class="fa fa-hashtag"></i>
                            <strong>Reference:</strong> {{ item.reference }}
                        </div> -->
                    </div>
                </div>
            </div>

            <!-- Pagination Controls -->
            <div class="pagination-wrapper" *ngIf="!loading && filteredTransactions && filteredTransactions.length > 0">
                <pagination-controls class="d-flex justify-content-center my-pagination"
                    (pageChange)="onPageChange($event)"></pagination-controls>

                <!-- Results Summary -->
                <div class="results-summary text-center mt-2">
                    <small class="text-muted">
                        Showing {{ ((page - 1) * itemsPerPage) + 1 }} to
                        {{ Math.min(page * itemsPerPage, total) }} of {{ total }} transactions
                    </small>
                </div>
            </div>
        </div>
    </div>
</div>
